import React, { useState } from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import LineImg2 from '../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/line_2.png'
import LineImg3 from '../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/line_3.png'
import LeftArrow from '../../../Assets/images/DFL/landing-page-img/left-arrow.png'
import RightArrow from '../../../Assets/images/DFL/landing-page-img/right-arrow.png'



import img1 from "../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/dimond-eng-ring/img1.png";
import img2 from "../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/dimond-eng-ring/img2.png";
import img3 from "../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/dimond-eng-ring/img3.png";
import img4 from "../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/dimond-eng-ring/img4.jpg";
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';

import { LazyLoadImage } from "react-lazy-load-image-component";
import { IoMdHeartEmpty } from "react-icons/io";


import Slider from 'react-slick'
import { NavLink, useHistory } from 'react-router-dom'
import { store } from '../../../Store/store';
import { cartlengthvalue } from '../../../Reducer/cartReducer';
import { whishlistlength } from '../../../Reducer/wishlistReducer';
import { base_url, currencycode, isLogin, postHeader, user } from '../../../Helpers/request';
import { toast } from 'react-toastify';
import axios from 'axios'

const DiamondEngamentRing = () => {
    
    const history = useHistory()
 const [listdata, setListdata] = useState([]);
 const addtowishlist = (product_id, wishindex, id) => {
        const data = {
            currency_code: currencycode,
            user_id: user.user_id ? user.user_id : "",
            session_id: localStorage.getItem("dfl-session-id") ? localStorage.getItem("dfl-session-id") : "",
            product_id: product_id,
            type: 'JEWELRY',
            token: isLogin ? user.token : "",
        }
        axios.post(base_url + '/order/add_to_wishlist', data, {
            headers: postHeader
        })
            .then(res => {
                if (res.data.status == 1) {
                    if (id) {
                        const productlist = listdata.map(
                            (obj, index) => (index == wishindex ? Object.assign(obj, { is_wishlist: res.data.data.wishlist_id }) : obj)
                        )
                        setListdata(productlist)
                    }
                    store.dispatch(whishlistlength(res.data.data.count))
                    toast.success(res.message, { autoClose: 3000 });
                } else if (res.data.status == 2) {
                    localStorage.removeItem('dfl-user')
                    store.dispatch(whishlistlength())
                    store.dispatch(cartlengthvalue(0))
                    localStorage.removeItem("dfl-session-id")
                    history.push("/")
                    window.location.reload(true);
                } else {
                    toast.error(res.message, { autoClose: 3000 });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    const settingsShopByShape = {
        dots: false,
        infinite: true,
        speed: 500,
        prevArrow: <img src={LeftArrow} />,
        nextArrow: <img src={RightArrow} />,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const ShopByShapData = [
        {
            text: "18K White Gold Hidden Halo Round Engagement Rings",
            image: img1,
            url: "/ringsettingdetail/setting/18k-white-gold-hidden-halo-round-engagement-rings-hidden-halo-engagement-ringsugrweueccw-51159-E-1-4-319319",
        },
        {
            text: "18K White Gold 3 Stone Engagement Rings",
            image: img2,
            url: "/ringsettingdetail/setting/18k-white-gold-3-stone-engagement-rings-3-stone-engagement-ringsdykgowiaae-83467-301133",
        },
        {
            text:"18K White Gold Halo Round Engagement Rings",
            image: img3,
            url:  "/ringsettingdetail/setting/18k-white-gold-halo-round-engagement-rings-halo-engagement-ringshlvhcynvdp-50891-E-1-4-308490",
        },
        {
            text: "18K White Gold Single Row Round Engagement Rings",
            image: img4,
            url: "/ringsettingdetail/setting/18k-white-gold-single-row-round-engagement-rings-single-row-engagement-ringsnggllymkjx-51102-E-1-4-325745",
        },
       
    ]


    return (
        <div className='dfl_eng_Shop_ring_by_style_section DiamondEngamentRing_section'>
            <Container className='dfl_custome_container_staticpage'>
                <Row>
                    <Col sm={12} md={12} lg={12}>
                        <div>
                            <div class="title-box2 text-center border-title mb-0">
                                <h2 class="title24 title-box2 dark">Diamond Engagement Rings</h2>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={12} lg={12}>
                        <div className='dfld_shap_slider dfl___diamond_shap_slider'>
                            <Slider {...settingsShopByShape} className="dfld_explore_diamond_shap_slider">
                                {ShopByShapData.map((val, index) => (
                                    <div className='dfld_img_shap_box_inner dfl_eng_ring_img'>
                                            <div className='dfld_img_shap_box_outer'>
                                                <NavLink  to={val.url}>
                                                     <Image src={val.image} alt={val.shape}/>
                                                  </NavLink>
                                  
                                            <div className='wishlist_text_boxxxxx'>
                                            <p  onClick={() => history.push(val.url)} style={{ cursor: "pointer" }}>{val.text}</p>
                                            {/* <IoMdHeartEmpty /> */}
                                     
                                                                  <div className="rcs_prod_info d_space_between pt-0">
                                                                                                        <div className="d-flex align-items-start pt-10">
                                                                                                            {/* <h2  className="rcs_list_title">{val.name}</h2> */}
                                                                                                            <button className="rcs_wish_btn rcs_wish_btn_desktop">{val.is_wishlist == "0" ? <FavoriteBorderIcon onClick={() => addtowishlist(val.product_id, index, 1)} /> : <FavoriteBorderIcon onClick={() => addtowishlist(val.product_id, index, 1)} />
                                                                                                            
                                                                                                            //  <FavoriteIcon onClick={() => addtowishlist(val.product_id, index, 1)} className="animate__animated animate__heartBeat" />
                                                                                                             }</button>
                                                                                                        </div>
                                                                                                    </div>
                                            </div>
                                            </div>
                                        
                                        </div>
                                ))}
                            </Slider>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={12} lg={12}>
                    <div className='text-center'>
                         <button className='btn_design_your_ring mb-0' onClick={() => history.push("/ringsettings")}>View All</button>
                    </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default DiamondEngamentRing